export const reclamaPremioConstants = {
  LIST_RECLAMO_REQUEST: 'LIST_RECLAMO_REQUEST',
  LIST_RECLAMO_SUCCESS: 'LIST_RECLAMO_SUCCESS',
  LIST_RECLAMO_FAILURE: 'LIST_RECLAMO_FAILURE'
};
